<div class="publish-container">

    @for (gallery of galleries$ | async; track gallery)
    {
        <div>
            <mat-card>
                <mat-card-content>
                    {{gallery.location}}
                    @if (!gallery.isPublished && !gallery.isPublishing)
                    {
                        <button mat-icon-button (click)="publishGallery(gallery)">
                            <mat-icon>publish</mat-icon>
                        </button>
                    }
                    @if (gallery.isPublishing)
                    {
                        <img src="../../../assets/aperture.gif" />
                    }
                    @if (gallery.isPublished)
                    {
                        <mat-icon>published_with_changes</mat-icon>
                    }
                </mat-card-content>
            </mat-card>
        </div>
    }

    @if ((noneAvailable | async) && !(availableRequested | async))
    {
        <p>refresh available to see galleries...</p>
    }
    @if (availableRequested | async)
    {
        <p>requesting available galleries...</p>
    }

</div>
